import React, { useContext } from 'react';
import { IEditSubCategoryContext, EditSubCategoryContext } from '../../../editSubCategoryState/editSubCategoryContext';
import { MenuTranslationForm } from 'components/TranslationForm/MenuTranslationForm';

interface ITranslationsForm {
	isVisible: boolean;
}

const TranslationsForm: React.FC<ITranslationsForm> = ({ isVisible }) => {
	const {
		setDefaultCustomerLanguage,
		setTranslationTab,
		changeNameTranslation,
		IDSelectedCustomer,
		translations,
		selectedTranslationTab,
	} = useContext<IEditSubCategoryContext>(EditSubCategoryContext);
	return (
		<MenuTranslationForm
			setDefaultCustomerLanguage={setDefaultCustomerLanguage}
			setTranslationTab={setTranslationTab}
			changeNameTranslation={changeNameTranslation}
			isVisible={isVisible}
			IDSelectedCustomer={IDSelectedCustomer}
			translations={translations}
			selectedTranslationTab={selectedTranslationTab}
		/>
	);
};

export default TranslationsForm;
